// Via some Webpack magic, we can import every enum type from the GraphQL
// schema as a JavaScript object
import { SortDirection } from "graphql/schema.graphql";
export const { ASC, DESC } = SortDirection;

export {
  AlertSort,
  ApiTokenSort,
  ApmHostSort,
  ApmHttpMethodSort,
  ApmHttpStatusSort,
  ApmServiceSort,
  ApmTracedOutboundCallsSortEnum,
  ApmTracedRequestsSortEnum,
  ApmTransactionSort,
  CacheCallSort,
  DatabaseQuerySort,
  ExceptionGroupSortEnum,
  TracedExceptionSortEnum,
  DashboardSort,
  MetricsReportSort,
  UsageReportSort,
  InfrastructureHostSort,
  InvoiceSort,
  NotificationServiceSort,
  RemoteServiceSort,
  SortDirection,
} from "graphql/schema.graphql";
